import type ja from './ja';

const en = {
    title: '<strong>I confirm and agree to the following:</strong>',
    termsAndConditions: {
        label: 'Terms & Conditions Check',
        description: `・<strong>Item Count Confirmation</strong>: I confirm that the total number of items handed over is correct as displayed on the screen.
・<strong>Liability Exclusion</strong>: I confirm that my luggage does NOT contain electronics (laptops/cameras), fragile items (glass/alcohol), or valuables (cash/passports). I agree that these items are NOT compensated.
・<strong>Compensation Limit</strong>: I agree that the maximum compensation is 300,000 JPY per item, and minor surface damage (scratches/wear on wheels) is excluded from coverage.
・<strong>24-Hour Rule</strong>: I understand that any damage claims must be reported within 24 hours of receiving the luggage. Claims after this period are invalid.
・<strong>Penalty & Terms</strong>: I agree to the 30,000 JPY penalty for fraudulent use (e.g., no hotel reservation) and accept the full Terms of Service.`,
    },
    // Consent screen additional confirmation items
    passportNotInside: {
        label: 'Passport Confirmation',
        description: 'Passport is <strong>NOT</strong> inside',
    },
    counterVerification: {
        label: 'Counter Verification',
        description: 'Final count verified at the counter',
    },
    // Confirmation screen items (5 individual checkboxes)
    itemCountConfirmation: {
        label: 'Item Count Confirmation',
        description: 'I confirm that the total number of items handed over is correct as displayed on the screen.',
    },
    liabilityExclusion: {
        label: 'Liability Exclusion',
        description:
            'I confirm that my luggage does NOT contain <strong>electronics (laptops/cameras), fragile items (glass/alcohol), or valuables (cash/passports)</strong>. I agree that these items are NOT compensated.',
    },
    compensationLimit: {
        label: 'Compensation Limit',
        description:
            'I agree that the maximum compensation is <strong>300,000 JPY per item</strong>, and <strong>minor surface damage (scratches/wear on wheels)</strong> is excluded from coverage.',
    },
    claimDeadline: {
        label: '24-Hour Rule',
        description:
            'I understand that any damage claims must be reported <strong>within 24 hours of receiving the luggage</strong>. Claims after this period are invalid.',
    },
    penaltyAndTerms: {
        label: 'Penalty & Terms',
        description:
            'I agree to the <strong>30,000 JPY penalty</strong> for fraudulent use (e.g., no hotel reservation) and accept the full [Terms of Service].',
    },
} satisfies typeof ja;

export default en;
